



































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FlSelect extends Vue {
  @Prop({ default: '' }) private value!: any;
  @Prop({ default: () => [] }) private options!: object[];
  @Prop({ default: false }) private required!: boolean;
  @Prop({ default: '' }) private label!: string;
  @Prop({ default: '' }) private sublabel!: string;
  @Prop({ default: '' }) private explanation!: string;
  @Prop({ default: false }) private unselected!: boolean;
  @Prop({ default: '' }) private fieldId!: string;
  @Prop({ default: () => [] }) private errors!: string[];
  @Prop({ default: true }) private needsTranslation?: boolean;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private nullable!: boolean;
  @Emit('input')
  input(newValue: any) {
    let convertValue = newValue.match(/^\d+$/) ? parseInt(newValue) : newValue;
    if (!convertValue && this.nullable) {
      convertValue = null;
    }
    return convertValue;
  }
  get inputValue() {
    // if (!this.unselected && !this.value) {
    //   // タイムゾーン指定の問だけブラウザの設定地域をデフォルトにする
    //   const value: any = this.fieldId === 'timezone' ? Intl.DateTimeFormat().resolvedOptions().timeZone : '';
    //   return value;
    // } else {
    return this.value;
  }
  get validateRule() {
    const rule = this.required ? 'required' : '';
    return rule;
  }
  get fieldName() {
    if (!this.label) {
      return this.$t('commons.this_field');
    }
    let fieldName = this.label;
    if (this.sublabel) {
      fieldName = this.label + `(${this.sublabel})`;
    }
    return fieldName;
  }
  setInputValue(event: any) {
    this.input(event.target.value);
    this.$emit('change', event);
  }
}
